import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const FamilyWalletWithdrawalAdmin = () => {
    const currentYear = new Date().getFullYear();

    // Default to December 2023 - 5 January 2024
    const [month, setMonth] = useState(() => localStorage.getItem("selectedMonth") || 12);
    const [year, setYear] = useState(() => localStorage.getItem("selectedYear") || 2024);
    const [status, setStatus] = useState(() => localStorage.getItem("selectedStatus") || 0); // Default status is Pending
    const [withdrawalData, setWithdrawalData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASEURL5}/admin/withdrawal/familyWalletAdmin?month=${(month%12 + 1)}&year=${year}&status=${status}`
            );
            const data = await response.json();
            setWithdrawalData(data);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [month, year, status]); // Include status in the dependency array

    const handleMonthChange = (e) => {
        setMonth(e.target.value);
        localStorage.setItem("selectedMonth", e.target.value);
    };

    const handleYearChange = (e) => {
        setYear(e.target.value);
        localStorage.setItem("selectedYear", e.target.value);
    };

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
        localStorage.setItem("selectedStatus", e.target.value);
    };

    // Helper function to get the month range like "Dec - 5 Jan"
    const getMonthRange = (m) => {
        const startMonth = new Date(0, m - 1).toLocaleString("default", { month: "short" });
        const nextMonth = new Date(0, m).toLocaleString("default", { month: "short" });
        return `${startMonth} - 5 ${nextMonth}`;
    };

    // Generate month ranges without year starting from December
    const generateMonthOptions = () => {
        const months = [];
        let startMonth = 12; // December

        // Generate 12 month ranges starting from Dec - 5 Jan
        for (let i = 0; i < 12; i++) {
            const range = getMonthRange(startMonth);
            months.push({ month: startMonth, range });

            // Move to the next month
            if (startMonth === 12) {
                startMonth = 1;
            } else {
                startMonth += 1;
            }
        }
        return months;
    };

    const totalAmount = withdrawalData?.totalAmountForAllBds || 0;

    const monthOptions = generateMonthOptions();

    return (
        <div>
            <section className="content-header">
                <h1>Family Wallet Withdrawal</h1>
            </section>

            <section className="content">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="box">
                            <div className="box-body">
                                <div style={{ marginBottom: "20px", display: "flex", gap: "10px" }}>
                                    <div>
                                        <label htmlFor="month">Month:</label>
                                        <select id="month" value={month} onChange={handleMonthChange}>
                                            {Array.from({ length: 12 }, (_, m) => (
                                                <option key={m + 1} value={m + 1}>
                                                    {getMonthRange(m + 1)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label htmlFor="year">Year:</label>
                                        <select id="year" value={year} onChange={handleYearChange}>
                                            {[...Array(5).keys()].map((y) => (
                                                <option key={currentYear - y} value={currentYear - y}>
                                                    {currentYear - y}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label htmlFor="status">Status:</label>
                                        <select id="status" value={status} onChange={handleStatusChange}>
                                            <option value={0}>Pending</option>
                                            <option value={1}>Approved</option>
                                            <option value={2}>Rejected</option>
                                        </select>
                                    </div>
                                </div>

                                {loading ? (
                                    <p>Loading...</p>
                                ) : (
                                    <>
                                        <table className="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th>SNo</th>
                                                    <th>Image</th>
                                                    <th>BD Name</th>
                                                    <th>BD Code</th>
                                                    <th>INR</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {withdrawalData?.bds?.map((bd, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <img
                                                                src={`${process.env.REACT_APP_BASEURL1}${bd.image}`}
                                                                alt={bd.bdName}
                                                                style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                                                            />
                                                        </td>
                                                        <td>{bd.bdName}</td>
                                                        <td>{bd.bdCode}</td>
                                                        <td>{bd.totalAmount}</td>
                                                        <td> <Link
                                                            role="menuitem"
                                                            tabIndex={-1}
                                                            to={`/admin/FamilyWalletWithdrawalAdminView?bd=${bd.bdCode}`}
                                                        >
                                                            View
                                                        </Link></td>
                                                    </tr>
                                                ))}
                                                {/* Total Amount Row */}
                                                <tr style={{ fontWeight: "bold" }}>
                                                    <td>Total</td>
                                                    <td colSpan={3} style={{ textAlign: "right" }}></td>
                                                    <td>{totalAmount}</td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FamilyWalletWithdrawalAdmin;
